import { fadeInUp } from '@/constants/motions';
import Image from '@/ui/Image';
import { motion } from 'framer-motion';

export default function TextImageAsideDarkBlock({
  imageDirection,
  image,
  subtitle,
  title,
  children,
}) {
  const order = {
    left: 'order-1',
    right: 'lg:order-2',
  }[imageDirection];

  return (
    <motion.section
      className="relative py-16 px-4 text-white lg:my-24 lg:py-8"
      initial="hidden"
      transition={{
        ...fadeInUp.transition,
        when: 'beforeChildren',
        staggerChildren: 0.4,
      }}
      variants={fadeInUp}
      viewport={fadeInUp.viewport}
      whileInView="visible"
    >
      <div className="absolute inset-0 h-full w-full bg-primary-700"></div>
      <div className="container-screen relative">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <motion.div className={order} variants={fadeInUp}>
            <Image
              alt="Image"
              className="aspect-video max-w-screen-sm overflow-hidden rounded-xl object-cover shadow-lg lg:-my-16 lg:aspect-square"
              src={image}
            />
          </motion.div>
          <motion.div className="order-1" variants={fadeInUp}>
            {subtitle && <h3 className="text-xl opacity-60 lg:text-2xl">{subtitle}</h3>}
            <h2 className="mt-4 text-3xl md:text-4xl xl:text-5xl">{title}</h2>
            <div className="prose mt-6 max-w-none leading-normal text-inherit">{children}</div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
}
